var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('span',[_vm._v("自动登录中,请稍后")]),_vm._v(" "),_vm._l((_vm.points),function(i){return _c('span',{key:i},[_vm._v(".")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }